import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/home/Home';
import { About } from './pages/about/About';
import { Parteners } from './pages/parteners/Parteners';
import { Contact } from './pages/contact/Contact';
// import { Solutions } from './pages/solutions/Solutions';
import { AskCharlee } from './pages/products/askcharlee/AskCharlee';
import { SeeCharlee } from './pages/products/seecharlee/SeeCharlee';
import { DocuCharlee } from './pages/products/docucharlee/DocuCharlee';
import { FindCharlee } from './pages/products/findcharlee/FindCharlee';
// import { Blogs } from './pages/blogs/Blogs';
// import { BlogContent } from './pages/blogs/BlogContent';
// import { EventContent } from './pages/blogs/EventContent';
// import { Usecase } from './pages/usecase/Usecase';
import ResearchPage from './pages/research/research';
import { VideoPages } from './pages/videos/videos';
import { RiteCharlee } from './pages/products/ritecharlee/RiteCharlee';
import { HubLayout } from './pages/new/layout/HubLayout';
import { HubSection } from './pages/new/layout/HubSection';
import { EventDetail } from './pages/new/event/EventDetail';
import { PodcastDetail } from './pages/new/podcast/PodcastDetail';
import { BlogDetail } from './pages/new/blog/BlogDetail';
import { UsecaseDetail } from './pages/new/usecase/UsecaseDetail';
import { NotFound } from './pages/notFound/NotFound';

 export const Router = () => {
  return (
    <BrowserRouter >
      <Routes >
        <Route path="/articles/event/:eventName" element={<EventDetail />} />
        <Route path="/articles/podcast/:podcastName" element={<PodcastDetail />} />
        <Route path="/articles/blog/:blogName" element={<BlogDetail />} />
        <Route path="/articles/usecase/:usecaseName" element={<UsecaseDetail />} />
        <Route path="/articles" element={<HubLayout />}>
          <Route index element={<Navigate to="all" replace />} />
          <Route path=":section" element={<HubSection />} />
        </Route>
        <Route path="/" element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/partners' element={<Parteners />} />
        <Route path='/connect' element={<Navigate to="/contact" replace />} />
        <Route path='/contact' element={<Contact />} />
        {/*
          Legacy routes disabled — replaced by /articles hub and detail pages.
          <Route path='/solutions1' element={<Solutions />}/>
          <Route path="/blogs/*" element={<Blogs />} />
          <Route path="/event/:eventname" element={<EventContent />} />
          <Route path="/blog/*" element={<BlogContent />} />
          <Route path='/usecase/*' element={<Usecase />} />
        */}
        <Route path='/product/askcharlee' element={<AskCharlee />} />
        <Route path='/product/seecharlee' element={<SeeCharlee />} />
        <Route path='/product/docucharlee' element={<DocuCharlee />} />
        <Route path='/product/findcharlee' element={<FindCharlee />} />
        <Route path='/product/ritecharlee' element={<RiteCharlee />} />
        <Route path='/solutions' element={<ResearchPage />} />
        <Route path='/videos-page' element={<Navigate to="/videos" replace />} />
        <Route path='/videos' element={<VideoPages />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
